<template>
    <div class="row page-row report">
        <div class="col-sm-12">
            <h1>Under construction</h1>
        </div>
    </div>
</template>

<script>
    export default {
        components: { },
        data() {
            return {}
        },
        watch: {
        },
        computed: {
        },
        mounted() {

        },
        methods: {
        }
    }
</script>
